// Block Definition: criteria_list
// Static layout block — a scored criteria list with badge + label + write box per row.
// No data extraction. Items are declared in the DSL.

export const criteriaListDef = {
  type: "criteria_list",
  label: "Criteria List",
  description: "Scored criteria rows with badge, label and write-in box.",
  crystallizer: null,
  renderer: null, // wired by ui/src/blockRegistryInit.js
  editor: {
    icon: "list",
    category: "layout",
    defaultTemplate: { type: "criteria_list", items: [] },
    configFields: [
      { name: "items", type: "array", label: "Criteria items" },
    ],
  },
};
